const pacificCity =
  'https://lh3.googleusercontent.com/wVlFp6fF9dH3j-uB0GmjwFZ2n4IR0HTZ3IlKpxsRnXxgCqHHjBjTPpJSgZsOhHvf20frYY_d_jUEMfjkyrGVnC0ob_xSCkITJatNR3dZcmMAiQVRM1DL6aVrFY9tEspgAl8PH-Wdsw=w2400';

export default pacificCity;
